/* eslint-disable */
/*!
 * Freshdesk Messaging Facade v1.3.0 (https://github.com/coliff/freshdesk-messaging-facade)

Copied fron node_modules and edited to call our own initialzation function - changes are annotated
 */


// it's hidden by default for browsers with JavaScript disabled
// this removes the hidden attribute
/* TV - move unhide to init.js
document.getElementById("freshdesk-messaging-facade").removeAttribute("hidden");
*/

class FreshchatFacade extends HTMLElement {
  connectedCallback() {
    this.siteId = this.getAttribute("data-siteid");
    this.token = this.getAttribute("data-token");
    this.host = this.getAttribute("data-host") || "https://wchat.freshchat.com";

    this.addEventListener("pointerover", FreshchatFacade.warmConnections, {
      once: true,
    });

    this.addEventListener("pointerover", () => this.addScript());
  }

  // Add a <link rel=preconnect ...> to the head
  static addPrefetch(kind, url, as) {
    var linkEl = document.createElement("link");
    linkEl.rel = kind;
    linkEl.href = url;
    if (as) {
      linkEl.as = as;
    }
    document.head.append(linkEl);
  }

  static warmConnections() {
    if (FreshchatFacade.preconnected) return;
    FreshchatFacade.addPrefetch("preconnect", this.host);
    FreshchatFacade.addPrefetch("preconnect", "https://assetscdn-wchat.freshchat.com");
    FreshchatFacade.preconnected = true;
  }

  addScript() {
    var script = document.createElement("script");
    script.src = "https://wchat.freshchat.com/js/widget.js";
    document.head.append(script);

    // hide the button if script fails to load
    script.onerror = function () {
      document.getElementById("freshdesk-messaging-facade").setAttribute("hidden", "hidden");

      /* TV - Add logrocket and bugsnag notifications on error */
      if (LogRocket) {
        LogRocket.captureMessage('Freshchat window.fcWidget did not initialize.', {
            tags: {
                level: 'error',
                url: window.location.href
            }
        });
      }

      if (window.bugsnagClient) {
        window.bugsnagClient.notify(new Error('Freshchat window.fcWidget did not initialize.'));
      }
    };

    // display a loading spinner when script is loading
    script.onload = function () {
      document.getElementById("freshdesk-messaging-icon").classList.add("freshdesk-messaging-icon-loading");
    };

    /* TV - call our own initialization function instead
    fcWidget.init({
      token: this.token,
      host: this.host,
      siteId: this.siteId,
      config: {
        headerProperty: {
          hideChatButton: false,
        },
      },
    });
    */
    if (typeof fcWidget !== 'undefined') {
      init_and_set_properties(fcWidget);
      // Hide the facade once the real one has loaded
      fcWidget.on("widget:opened", function () {
          document.getElementById("freshdesk-messaging-facade").setAttribute("hidden", "hidden");
      });
    }
  }
}

// Register custom element
customElements.define("freshdesk-messaging-facade", FreshchatFacade);
